var _title, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoNewRelic = function SvgLogoNewRelic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "New Relic")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#008C99",
    d: "M44.699 19.21C42.775 10.369 32.175 5.171 21.018 7.595 9.862 10.02 2.379 19.154 4.301 27.992 6.222 36.83 16.826 42.033 27.98 39.606c11.154-2.427 18.641-11.549 16.719-20.396ZM24.501 31.749a8.144 8.144 0 0 1-7.528-5.03 8.15 8.15 0 1 1 7.528 5.03Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#70CCD3",
    d: "M26.302 12.193A11.696 11.696 0 0 0 14.83 26.177a11.7 11.7 0 1 0 11.472-13.984Zm-1.803 18.525a7.115 7.115 0 0 1-6.981-8.506 7.124 7.124 0 0 1 5.592-5.592A7.116 7.116 0 1 1 24.5 30.718h-.002Z"
  })));
};
export default SvgLogoNewRelic;